export default "__VITE_ASSET__Ce2Ys6lh__"